import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

export interface ProductCardExpandedListItem {
  color?: string,
  icon: string,
  content: string,
}

export interface ProductCard {
  content?: string,
  expandedList?: ProductCardExpandedListItem[],
  image: string,
  logo?: string,
  subtitle?: string,
  title: string,
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-product-card',
  styleUrls: ['./product-card.component.scss'],
  templateUrl: './product-card.component.html',
})
export class ProductCardComponent {

  @Input() product: ProductCard;

  @HostBinding('class.hoverable')
  @Input() hoverable = true;

  @HostBinding('class.expanded') expanded = false;

  constructor() { }

}
